import type { CourseConversation } from "@/lib/api/inbox";
import { inboxWords as words, messageTime } from "./inbox-copy";

/** A conversation's messages stay inside the row that owns its reply. */
export function ConversationThread({ conversation, actor }: { conversation: CourseConversation; actor: string }) {
  if (!conversation.messages.length) return <p className="text-ui text-muted-foreground">{words.noConfirmedMessages}</p>;
  return <ol aria-label={words.messages} className="grid gap-4 py-3">
    {conversation.messages.map(message => <li key={message.id} className="grid gap-2 border-t border-rule pt-3">
      <p className="flex flex-wrap justify-between gap-2 text-meta text-muted-foreground">
        <span>{message.sender_user_id === actor ? words.you : conversation.participants.find(person => person.user_id === message.sender_user_id)?.name ?? words.participant}</span>
        <time dateTime={message.sent_at}>{messageTime(message.sent_at)}</time>
      </p>
      <p className="whitespace-pre-wrap break-words text-body">{message.body}</p>
    </li>)}
  </ol>;
}

